import React from 'react';
import './index.css';

const serviceData = [
  {
    icon: '📝',
    title: 'Test Preparation (IELTS/PTE/GRE)',
    description:
      'Ace your tests, unlock your university options.',
  },
  {
    icon: '🗣️',
    title: 'Free Expert Counselling',
    description:
      'Your personalized path to studying abroad starts here',
  },
  {
    icon: '🎓',
    title: 'Country & Course Selection',
    description:
      'Find your perfect fit, globally',
  },
  {
    icon: '🔍',
    title: 'University Selection',
    description:
      'Discover your best-suited international universities',
  },
  {
    icon: '✍️',
    title: 'Application Processing',
    description:
      'Stress-free applications, maximized chances',
  },
  {
    icon: '🔑',
    title: 'Admission Guidance',
    description:
      'Expert tips to get you accepted',
  },
  {
    icon: '💰',
    title: 'Scholarship Guidance',
    description:
      'Funding your dream, made easier',
  },
  {
    icon: '🏦',
    title: 'Education Loans Guidance',
    description:
      'Smart financing for your global education.',
  },
  {
    icon: '✈️',
    title: 'Visa Process Guidance',
    description:
      'Navigate your visa smoothly and confidently.',
  },
  {
    icon: '🗺️',
    title: 'Pre-departure Guidance',
    description:
      'Get ready for your adventure abroad.',
  },
  {
    icon: '🏠',
    title: 'Accommodation Guidance',
    description:
      'Find your ideal home away from home.',
  },
  {
    icon: '⚙️',
    title: 'Auxiliary Services',
    description:
      'Extra support for a seamless experience.',
  },
];

const ServiceCard = ({ icon, title, description }) => {
  return (
    <div className="service-card">
      <div className="service-icon-wrapper">{icon}</div>
      <h3 className="service-card-title">{title}</h3>
      <p className="service-card-description">{description}</p>
    </div>
  );
};

const ServiceCards = () => {
  return (
    <div className="service-card-container">
      {serviceData.map((service, index) => (
        <ServiceCard key={index} {...service} />
      ))}
    </div>
  );
};

export default ServiceCards;